<div class="container-fluid py-3">
  <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
    <div class="row g-3">
      <!-- First Name -->
      <div class="col-12 col-md-6">
        <label for="firstName" class="form-label">First Name</label>
        <input
          type="text"
          id="firstName"
          class="form-control"
          formControlName="first_name"
          placeholder="Ex. John"
        />
        <div
          *ngIf="
            f.first_name.invalid && (f.first_name.dirty || f.first_name.touched)
          "
          class="text-danger"
        >
          <small *ngIf="f.first_name.errors?.required"
            >First name is required</small
          >
        </div>
      </div>

      <!-- Last Name -->
      <div class="col-12 col-md-6">
        <label for="lastName" class="form-label">Last Name</label>
        <input
          type="text"
          id="lastName"
          class="form-control"
          formControlName="last_name"
          placeholder="Ex. Doe"
        />
        <div
          *ngIf="
            f.last_name.invalid && (f.last_name.dirty || f.last_name.touched)
          "
          class="text-danger"
        >
          <small *ngIf="f.last_name.errors?.required"
            >Last name is required</small
          >
        </div>
      </div>

      <!-- Mobile -->
      <div class="col-12 col-md-6">
        <label for="mobileNumber" class="form-label">Mobile Number</label>
        <input
          type="text"
          id="mobileNumber"
          class="form-control"
          formControlName="mobile"
          placeholder="Enter 10 digits number"
        />
        <div
          *ngIf="f.mobile.invalid && (f.mobile.dirty || f.mobile.touched)"
          class="text-danger"
        >
          <small *ngIf="f.mobile.errors?.required"
            >Mobile number is required</small
          >
          <small *ngIf="f.mobile.errors?.pattern">Invalid mobile number</small>
        </div>
      </div>

      <!-- Email -->
      <div class="col-12 col-md-6">
        <label for="emailAddress" class="form-label">Email Address</label>
        <input
          type="email"
          id="emailAddress"
          class="form-control"
          formControlName="email"
          placeholder="Ex. abc@gmail.com"
          [disabled]="true"
        />
        <div
          *ngIf="f.email.invalid && (f.email.dirty || f.email.touched)"
          class="text-danger"
        >
          <small *ngIf="f.email.errors?.required">Email is required</small>
          <small *ngIf="f.email.errors?.email">Invalid email address</small>
        </div>
      </div>

      <!-- Designation -->
      <div class="col-12 col-md-6">
        <label for="designation" class="form-label">Designation</label>
        <select
          id="designation"
          class="form-select"
          formControlName="designation"
        >
          <option value="">Select Designation</option>
          <option
            *ngFor="let designation of designations"
            [value]="designation"
          >
            {{ designation }}
          </option>
        </select>
        <div
          *ngIf="
            f.designation.invalid &&
            (f.designation.dirty || f.designation.touched)
          "
          class="text-danger"
        >
          <small *ngIf="f.designation.errors?.required"
            >Designation is required</small
          >
        </div>
      </div>
    </div>

    <!-- Buttons -->
    <div class="d-flex justify-content-end mt-4 gap-2">
      <button
        type="button"
        class="btn custom-button"
        (click)="onCancel()"
        data-bs-dismiss="modal"
      >
        Cancel
      </button>
      <button type="submit" class="btn custom-button">Update</button>
    </div>
  </form>
</div>
